import React, { useEffect, useState } from 'react';
import { Alert, Box, Collapse, Grid, IconButton, Snackbar, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { ConfirmDialog, MdiIcon, Table } from '@components';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { mdiChevronUp, mdiContentSave, mdiPencil, mdiPlus, mdiTrashCan } from '@mdi/js';
import { useModal } from 'mui-modal-provider';
import historicoAlteracoes from './history/handleHistory';
const LinhasCotacao = ({ $state, CrmService, user, client, cotacao, updateTotalCotacao }) => {
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [snackBarSeverity, setSnackBarSeverity] = useState(undefined);
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [error, setError] = useState(false);
    const [filter, setFilter] = useState([]); // filtros a aplicar na tabela
    const [sort, setSort] = useState([]); // ordenação da tabela
    const [options, setOptions] = useState({
        filter: [], // exemplo -> [{name: 'nome', type: 'TEXT'}, {name: 'ultimoContacto', type: 'DATE', options: {format: 'YYYY-MM-DD'}}, ...]
        sort: [] // exemplo -> ['id', 'nome', 'ultimoContacto', 'contactoTelefonico', 'nif', 'email', 'morada', 'localidade']
    });
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 5
    });
    const [linhaCotacao, setLinhaCotacao] = useState(null);
    const [linhaCotacaoOriginal, setLinhaCotacaoOriginal] = useState(null); // Dados do Item antes de sofrer alterações (histórico de alterações)
    const [expand, setExpand] = useState(false);
    const validationSchema = yup.object().shape({
        item: yup.string().required('Preenchimento obrigatório'),
        descricao: yup.string().required('Preenchimento obrigatório'),
        quantidade: yup.number().required('Preenchimento obrigatório'),
        preco: yup.number().required('Preenchimento obrigatório')
    });
    const { showModal } = useModal();
    const formik = useFormik({
        initialValues: linhaCotacao ?? {
            id: 0,
            cotacaoId: 1,
            funcionarioId: user,
            item: '',
            descricao: '',
            quantidade: 1,
            prazo: 0,
            preco: 0,
            totalLinha: 0,
            active: 1
        },
        validationSchema: validationSchema,
        validateOnMount: false,
        validateOnChange: false,
        enableReinitialize: true,
        onSubmit: async (values) => {
            values.cotacaoId = cotacao.id;
            values.totalLinha = Number(values.totalLinha);
            let hist = await handleHistory(values, linhaCotacaoOriginal);
            submit(values, false, hist);
        }
    });
    const submit = async (value, remove, hist) => {
        let newValue = 0;
        let desconto = 0;
        try {
            const p = await CrmService.upsertLinhaCotacao(value, remove, cotacao, hist);
            setRefetching(true);
            fetchData();
            setExpand(false);
            remove ? setSnackBarMessage('Item removido com sucesso!') : setSnackBarMessage('Item registado com sucesso!');
            setSnackBarSeverity('success');
            setOpenSnackBar(true);
            formik.resetForm({
                values: {
                    id: 0,
                    cotacaoId: 0,
                    funcionarioId: user
                }
            });
            newValue = p.totalCotacao.newValue;
            desconto = p.totalCotacao.totalDesconto;
        }
        catch (error) {
            console.log(error);
            remove ? setSnackBarMessage('Erro ao remover Item.') : setSnackBarMessage('Erro ao registar Item.');
            setSnackBarSeverity('error');
            setOpenSnackBar(true);
        }
        updateTotalCotacao(newValue, desconto);
    };
    const handleHistory = async (linha, original) => {
        let fields = [];
        //console.log(original);
        if (original === null || linha.id === 0) {
            fields = [{ field: 'item', name: 'Item' }];
        }
        else {
            fields = [
                { field: 'cotacaoId', name: 'Linha de Cotação' },
                { field: 'item', name: 'Item' },
                { field: 'descricao', name: 'Descrição' },
                { field: 'quantidade', name: 'Quantidade' },
                { field: 'preco', name: 'Preço' },
                { field: 'prazo', name: 'Prazo' },
                { field: 'desconto', name: 'Desconto' },
                { field: 'totalLinha', name: 'Total Linha' },
                { field: 'totalComDesconto', name: 'Total com DEsconto' },
                { field: 'active', name: 'Item: ' + linha.item }
            ];
        }
        try {
            // objeto original, objeto com alterações, campos a considerar, e ID user Logado, estadoId da cotação opcional
            const h = await historicoAlteracoes(original ?? linhaCotacaoOriginal, linha, fields, user, cotacao.estadoId);
            if (original !== null && linha.id !== 0) {
                if (linha.active !== 0) {
                    h.observacoes = `Alterações no Item: \n"${linha.item}"\n ${h.observacoes}`;
                }
            }
            return h;
        }
        catch (error) {
            console.log(error);
        }
        return null;
    };
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const initialFetch = async () => {
        if (loading) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsLinhasCotacao();
            setOptions(opt);
            setLoading(false);
        }
    };
    const fetchData = async () => {
        setError(false);
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            if (cotacao.id !== undefined) {
                filters['cotacaoId'] = `$eq:${cotacao.id}`;
            }
            const aux = await CrmService.findAllLinhasCotacao({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            //console.log(aux);
            // Update URL
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            setData(aux);
        }
        catch (e) {
            console.log(e);
            setError(true);
        }
        setRefetching(false);
    };
    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };
    useEffect(() => {
        if (linhaCotacao) {
            formik.setValues(linhaCotacao);
        }
    }, [linhaCotacao]);
    // Table
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    useEffect(() => {
        const quantidade = formik.values?.quantidade || 0;
        const preco = formik.values?.preco || 0;
        const desconto = formik.values?.desconto || 0;
        // Calcula o total sem desconto
        const total = quantidade * preco;
        // Calcula o total com desconto
        const descontoAplicado = total * (desconto / 100);
        const totalComDesconto = total - descontoAplicado;
        if (quantidade !== 0 || preco !== 0) {
            formik.setFieldValue('totalLinha', total.toFixed(2)); // Mantém 2 casas decimais
            formik.setFieldValue('totalComDesconto', totalComDesconto.toFixed(2));
        }
    }, [formik.values?.quantidade, formik.values?.preco, formik.values?.desconto]);
    return (<Box>
      <Stack direction='row' justifyContent='flex-start' alignItems='center'>
        <Typography variant='h6' sx={{ color: 'black' }}>
          Linhas da Cotação
        </Typography>
        {client === undefined ? (<Box>
            {expand ? (<Tooltip title={'Cancelar'}>
                <IconButton color='primary' onClick={() => {
                    formik.resetForm();
                    setExpand(!expand);
                }}>
                  <MdiIcon path={mdiChevronUp} sx={{ color: '#1976D2' }}/>
                </IconButton>
              </Tooltip>) : (<Box></Box>)}
            {cotacao?.estadoId >= 60 ? (<></>) : (<Tooltip title={'Adicionar Item'}>
                <IconButton color='primary' onClick={() => {
                    if (expand) {
                        formik.handleSubmit();
                    }
                    else {
                        formik.resetForm();
                        setExpand(!expand);
                    }
                }}>
                  <MdiIcon path={!expand ? mdiPlus : mdiContentSave} sx={{ color: '#1976D2' }}></MdiIcon>
                </IconButton>
              </Tooltip>)}
          </Box>) : (<></>)}
      </Stack>

      <Collapse in={expand}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={6}>
            <TextField fullWidth id='item' label='Item' color='info' size='small' onChange={formik.handleChange} value={formik.values?.item} error={formik.touched.item && Boolean(formik.errors.item)} helperText={formik.touched.item && formik.errors.item}/>
          </Grid>
          <Grid item xs={12} md={8} lg={6}>
            <TextField fullWidth id='descricao' label='Descrição' color='info' size='small' onChange={formik.handleChange} value={formik.values?.descricao} error={formik.touched.descricao && Boolean(formik.errors.descricao)} helperText={formik.touched.descricao && formik.errors.descricao}/>
          </Grid>

          <Grid item xs={6} md={3} lg={3}>
            <TextField fullWidth id='quantidade' label='Quantidade' color='info' size='small' type='number' inputProps={{
            min: '0',
            step: '1', // Garante que só permite inteiros
            pattern: '[0-9]*' // Alguns browsers respeitam isso para evitar letras
        }} onKeyDown={e => {
            if (e.key === '.' || e.key === ',' || e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                e.preventDefault(); // Bloqueia a entrada de ponto e vírgula
            }
        }} onChange={formik.handleChange} value={formik.values?.quantidade} error={formik.touched.quantidade && Boolean(formik.errors.quantidade)} helperText={formik.touched.quantidade && formik.errors.quantidade}/>
          </Grid>

          <Grid item xs={6} md={3} lg={3}>
            <TextField fullWidth id='preco' label='Preço Unitário €' color='info' size='small' type='text' inputProps={{
            inputMode: 'decimal', // Exibe teclado numérico adequado em mobile
            pattern: '[0-9]+([,][0-9]{1,4})?' // Permite apenas números com ',' como separador decimal
        }} onChange={e => {
            let value = e.target.value;
            // Permite apenas números com ',' como separador decimal e até 4 casas decimais
            if (!/^\d*(,\d{0,4})?$/.test(value)) {
                return;
            }
            // Substitui "," por "." para armazenar corretamente
            const storedValue = value.replace(',', '.');
            formik.setFieldValue('preco', storedValue);
        }} onKeyDown={e => {
            if (['e', 'E', '+', '-'].includes(e.key)) {
                e.preventDefault(); // Bloqueia caracteres inválidos
            }
        }} value={formik.values.preco?.toString().replace('.', ',') || ''} error={formik.touched.preco && Boolean(formik.errors.preco)} helperText={formik.touched.preco && formik.errors.preco}/>
          </Grid>

          <Grid item xs={6} md={3} lg={3}>
            <TextField fullWidth id='prazo' label='Prazo (dias)' color='info' size='small' type='number' inputProps={{
            step: '1', // Garante que só permite inteiros
            min: '0',
            inputMode: 'decimal', // Exibe teclado numérico adequado em mobile
            pattern: '[0-9]*'
        }} onChange={e => {
            let value = e.target.value;
            if (!/^\d*$/.test(value)) {
                return;
            }
            formik.setFieldValue('prazo', value);
        }} onKeyDown={e => {
            if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
                e.preventDefault(); // Bloqueia caracteres inválidos
            }
        }} value={formik.values.prazo?.toString() || ''} error={formik.touched.prazo && Boolean(formik.errors.prazo)} helperText={formik.touched.prazo && formik.errors.prazo}/>
          </Grid>

          <Grid item xs={6} md={3} lg={3}>
            <TextField fullWidth id='desconto' label='Desconto %' color='info' size='small' type='text' inputProps={{
            inputMode: 'decimal',
            pattern: '[0-9]+([,][0-9]{1,4})?' // Permite até 4 casas decimais
        }} onChange={e => {
            let value = e.target.value;
            if (!/^\d*(,\d{0,4})?$/.test(value)) {
                return;
            }
            // Substitui "," por "." e limita a 100% (não pode dar mais que 100% de desconto)
            let storedValue = value.replace(',', '.');
            let descontoNum = parseFloat(storedValue);
            if (descontoNum > 100) {
                storedValue = '100';
            }
            formik.setFieldValue('desconto', storedValue);
        }} onKeyDown={e => {
            if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                e.preventDefault(); // Bloqueia caracteres inválidos
            }
        }} value={formik.values.desconto?.toString().replace('.', ',') || ''} error={formik.touched.desconto && Boolean(formik.errors.desconto)} helperText={formik.touched.desconto && formik.errors.desconto}/>
          </Grid>

          <Grid item xs={6} md={6} lg={6}>
            <TextField fullWidth id='totalLinha' label='Total Linha €' color='info' size='small' value={formik.values?.totalLinha ? formik.values.totalLinha.toString().replace('.', ',') : ''} disabled/>
          </Grid>

          <Grid item xs={6} md={6} lg={6}>
            <TextField fullWidth id='totalComDesconto' label='Total Linha com Desconto €' color='info' size='small' value={formik.values?.totalComDesconto ? formik.values.totalComDesconto.toString().replace('.', ',') : ''} disabled/>
          </Grid>
        </Grid>
      </Collapse>

      <Box sx={{
            mt: 1,
            borderRadius: '15px',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
        <Table storageKey={$state.current.name} data={data} columns={[
            {
                accessorKey: 'item',
                header: 'Item',
                size: 150
            },
            {
                accessorKey: 'descricao',
                header: 'Descrição',
                size: 150
            },
            {
                accessorKey: 'quantidade',
                header: 'Quantidade',
                size: 100,
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorKey: 'preco',
                header: 'Preço Unitário',
                size: 120,
                muiTableBodyCellProps: {
                    align: 'right'
                },
                Cell: ({ row }) => (row.original.preco ? row.original.preco.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 }) : 'N/D')
            },
            {
                accessorKey: 'prazo',
                header: 'Prazo (dias)',
                size: 120,
                muiTableBodyCellProps: {
                    align: 'right'
                },
                Cell: ({ row }) => (row.original.prazo ? row.original.prazo : 'N/D')
            },
            {
                accessorKey: 'desconto',
                header: 'Desconto',
                size: 120,
                muiTableBodyCellProps: {
                    align: 'right'
                },
                Cell: ({ row }) => (row.original.desconto ? row.original.desconto.toString().replace('.', ',') + ' %' : 'N/D')
            },
            {
                accessorKey: 'totalLinha',
                header: 'Total Linha',
                size: 100,
                muiTableBodyCellProps: {
                    align: 'right'
                },
                Cell: ({ row }) => (row.original.totalLinha ? row.original.totalLinha.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 }) : 'N/D')
            },
            {
                accessorKey: 'totalComDesconto',
                header: 'Total c/ Desconto',
                size: 100,
                muiTableBodyCellProps: {
                    align: 'right'
                },
                Cell: ({ row }) => (row.original.totalComDesconto ? row.original.totalComDesconto.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 }) : 'N/D')
            }
        ]} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} rowActionSize={120} actionItems={({ row }) => [
            <Box key={`actions-${row.original.id}`} display='flex' gap={1}>
              {client !== undefined || cotacao.estadoId >= 60 ? (<></>) : (<Stack direction='row' justifyContent='center' alignItems='center' spacing={2}>
                  <Tooltip title={'Editar dados'} placement='left'>
                    <IconButton color='primary' onClick={() => {
                        setExpand(true);
                        //formik.setValues(row.original);
                        setLinhaCotacao(row.original);
                        setLinhaCotacaoOriginal(row.original);
                    }}>
                      <MdiIcon path={mdiPencil} sx={{ color: '#1976D2' }}/>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={'Remover Item'} placement='left'>
                    <IconButton color='error' onClick={() => {
                        const wait = showModal(ConfirmDialog, {
                            title: 'Eliminar Item',
                            message: `Tem a certeza que pretende eliminar o Item "${row.original.item}"?`,
                            onClose: async (value) => {
                                if (value) {
                                    let temp = JSON.parse(JSON.stringify(row.original));
                                    temp.active = 0;
                                    let hist = await handleHistory(temp, row.original);
                                    submit(temp, true, hist);
                                }
                            }
                        });
                    }}>
                      <MdiIcon path={mdiTrashCan}/>
                    </IconButton>
                  </Tooltip>
                </Stack>)}
            </Box>
        ]}></Table>
      </Box>

      <Snackbar open={openSnackBar} autoHideDuration={4000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} onClose={handleSnackBarClose}>
        <Alert onClose={handleSnackBarClose} severity={snackBarSeverity} variant='filled' sx={{ width: '100%' }}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </Box>);
};
export default LinhasCotacao;
